import React from 'react';
import './ParentSidebar.css'; // Réutiliser le même style
import { ClipboardIcon, CalendarIcon, QuestionIcon } from './Icons';

function StudentSidebar({ activePage }) {
  const navigate = (page) => {
    if (window.navigateTo) {
      window.navigateTo(page);
    }
  };

  return (
    <aside className="parent-sidebar">
      <nav className="sidebar-nav">
        <a 
          href="#bulletin" 
          className={`nav-item ${activePage === 'student-dashboard' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); navigate('student-dashboard'); }}
        >
          <span className="nav-icon"><ClipboardIcon size={20} /></span>
          Bulletin de notes
        </a>
        
        <a 
          href="#emploi" 
          className={`nav-item ${activePage === 'student-emploi-du-temps' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); navigate('student-emploi-du-temps'); }}
        >
          <span className="nav-icon"><CalendarIcon size={20} /></span>
          Emploi du temps
        </a>
        
        <a 
          href="#support" 
          className={`nav-item ${activePage === 'support' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); navigate('support'); }}
        >
          <span className="nav-icon"><QuestionIcon size={20} /></span>
          Support et aides
        </a>
      </nav>
    </aside>
  );
}

export default StudentSidebar;
